// TODO: (@Juyeong-Byeon) selector에서 사용하는 로직 필드에서 react-signing을 사용하도록 수정후 isFieldsDataLabelValid 판별함수로 이동시키기
export default function calculateDuplication(
  param: Record<string, string>
): Record<string, boolean> {
  const invertedKeyValue: Record<string, string[]> = {};

  // TODO: (@Juyeong-Byeon) 아래 로직 단순화 시키기 https://github.com/modusign/modusign-client/pull/8901#discussion_r1253921529
  Object.keys(param).forEach((key) => {
    const value = param[key];
    if (!invertedKeyValue[value]) {
      invertedKeyValue[value] = [];
    }
    invertedKeyValue[value].push(key);
  });

  const result: Record<string, boolean> = {};
  Object.keys(invertedKeyValue).forEach((value) => {
    const keys = invertedKeyValue[value];
    if (keys.length > 1) {
      keys.forEach((fieldId) => {
        result[fieldId] = true;
      });
    } else if (keys.length === 1) {
      result[keys[0]] = false;
    }
  });

  return result;
}
